import { Component } from '@angular/core';

@Component({
  selector: 'app-info7moopen-component',
  imports: [],
  templateUrl: './info7moopen-component.html',
  styleUrl: './info7moopen-component.scss'
})
export class Info7moopenComponent {

}
